<div class="main-content">
	<h3 mat-dialog-title class="dialog-title">{{ dialogProperties.title }}</h3>
	<div mat-dialog-content class="dialog-container">
		<p>{{ dialogProperties.body }}</p>
	</div>
	<span [innerHTML]="content"></span>
	<div mat-dialog-actions>
		<div class="action-buttons">
			<button
				*ngFor="let button of buttons"
				(click)="emitClick(button)"
				mat-raised-button
				[color]="button.type"
			>
				{{ button.description }}
			</button>
		</div>
	</div>
</div>
